let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fJQbu")).then(() => parcelRequire('dcEuZ'));